import React, { FunctionComponent } from 'react';

// @ts-ignore
import { Slide } from 'react-slideshow-image';
import styled from 'styled-components';

const slideImages = [
  './assets/list.png',
  './assets/map.png',
  './assets/meet.png',
  './assets/chat.png',
];

type SlideImage = {
  image: string;
};

const SlideImage = styled.div<SlideImage>`
  background-image: url(${(props) => props.image});
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: contain;
  boxsizing: border-box;
  height: 480px;
`;

type PhoneSlider = {
  onChange: (oldIndex: number, newIndex: number) => void;
};

const PhoneSlider: FunctionComponent<PhoneSlider> = ({ onChange }) => {
  const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: false,
    arrows: false,
    pauseOnHover: true,
    onChange,
  };

  return (
    <div className="slide-container">
      <Slide {...properties}>
        <div className="each-slide">
          <SlideImage image={slideImages[0]} />
        </div>
        <div className="each-slide">
          <SlideImage image={slideImages[1]} />
        </div>
        <div className="each-slide">
          <SlideImage image={slideImages[2]} />
        </div>
        <div className="each-slide">
          <SlideImage image={slideImages[3]} />
        </div>
      </Slide>
    </div>
  );
};

export default PhoneSlider;
